export default __webpack_public_path__ + "static/media/andy.a5a8bd99.png";